import React, { useState } from 'react'
import { ErrorToaster, SuccessToaster } from '../../components/toaster/Toaster';
import { Box, Button, TextField, Typography } from '@mui/material';

const Support = () => {
     const [openSupport, setOpenSupport] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      ErrorToaster("Please fill all fields");
      return;
    }



    setSubmitted(true);
    setFormData({ name: "", email: "", message: "" });
    setOpenSupport(false)
  };
  return (
    <div>
      <Box
  sx={{
    maxWidth: 500,
    mx: "auto",
    mt: 4,
    p: 3,
    borderRadius: 2,
    boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
  }}
>
  <Typography variant="h6" fontWeight="bold" mb={2}>
    Contact Support
  </Typography>

  {submitted ? (
    <Box textAlign="center" py={4}>
      <Typography variant="h6" fontWeight="bold">
        Thank you for your inquiry submission.
      </Typography>

      <Typography sx={{ mt: 1 }}>
        Our support department will look into this and contact you.
      </Typography>

      <Button
        sx={{ mt: 3, background: "black", color: "white" }}
        onClick={() => setSubmitted(false)} // or navigate somewhere
      >
        Close
      </Button>
    </Box>
  ) : (
    <Box component="form" onSubmit={handleSubmit}>
      <TextField
        fullWidth
        label="Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        margin="normal"
      />

      <TextField
        fullWidth
        label="Email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        margin="normal"
      />

      <TextField
        fullWidth
        label="Message"
        name="message"
        value={formData.message}
        onChange={handleChange}
        margin="normal"
        multiline
        rows={4}
      />

      <Button
        type="submit"
        fullWidth
        sx={{
          mt: 2,
          background: "black",
          color: "white",
        }}
      >
        Submit
      </Button>

      <Typography
        sx={{
          mt: 3,
          fontSize: "13px",
          textAlign: "center",
          color: "gray",
        }}
      >
        For further assistance, feel free to email us at{" "}
        <a
          href="mailto:trackkmytrain@gmail.com"
          style={{
            color: "black",
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          trackkmytrain@gmail.com
        </a>
      </Typography>
    </Box>
  )}
</Box>

    </div>
  )
}

export default Support
